import {
  ActivityCategoryDTO,
  ActivityStatus,
  ApiListRequest,
  ApiListResponse,
  AppointableDTO,
  AppointableDtoStatus,
} from "@gymflow/types";
import {
  infiniteQueryOptions,
  QueryKey,
  queryOptions,
} from "@tanstack/react-query";

import { api } from "../../api";
import { numberPagination } from "../../numberPagination";

const keys = {
  all: () => ["memberApiAppointable"] as QueryKey,
  id: (id: unknown) => [...keys.all(), "id", id] as QueryKey,
  list: (filter: unknown) => [...keys.all(), "list", filter] as QueryKey,
  listCategories: (filter: unknown) =>
    [...keys.all(), "listCategories", filter] as QueryKey,
};

export const memberApiAppointable = {
  keys,
  queries: {
    id: (id: number | undefined) =>
      queryOptions({
        queryKey: keys.id(id),
        queryFn: async () => {
          return (await api.get<AppointableDTO>(`/customer/appointable/${id}`))
            .data;
        },
        enabled: id !== undefined,
      }),
  },
  infiniteQueries: {
    list: (
      params: {
        id?: number[];
        status?: AppointableDtoStatus;
        "appointableCategory.id"?: number[];
        allowOnlineBookings?: boolean;
        allowAppBookings?: boolean;
      } & ApiListRequest,
    ) =>
      infiniteQueryOptions({
        queryKey: keys.list(params),
        queryFn: async ({ pageParam }) => {
          return (
            await api.get<ApiListResponse<AppointableDTO>>(
              `/customer/appointable`,
              {
                params: { ...params, page: pageParam },
              },
            )
          ).data;
        },
        ...numberPagination,
      }),
    listCategories: (
      params: {
        statusList?: ActivityStatus[];
      } & ApiListRequest,
    ) =>
      infiniteQueryOptions({
        queryKey: keys.listCategories(params),
        queryFn: async ({ pageParam }) => {
          return (
            await api.put<ApiListResponse<ActivityCategoryDTO>>(
              `/customer/appointable/category/search`,
              { ...params, page: pageParam },
            )
          ).data;
        },
        ...numberPagination,
      }),
  },
  mutations: {},
};
